export default "__VITE_ASSET__CmgeN6C5__"